module.exports = __webpack_public_path__ + "../../static/img/unicorn.6428c566.png";